/* eslint @typescript-eslint/no-var-requires: "off" */
import React from 'react';
import cls from 'classnames';
import { useCurrentYear } from '../../../hooks/useCurrentYear';
import { LogoComp, LogoStyles, LogoOrientation, LogoColor } from '../Logo';

export interface IFooterProps {
  theme: 'dark' | 'light' | 'cloud';
  type?: 'default' | 'onlySocials';
}

export const Footer: React.FC<IFooterProps> = ({ theme, type }) => {
  const year = useCurrentYear();
  return (
    <footer
      className={cls('mt-auto', 'p-0', {
        'bg-cloud-900 text-white border-b border-t border-cloud-900': theme === 'dark',
        'bg-white text-cloud-900 border-b border-t border-cloud-900': theme === 'light',
        'bg-cloud-800 text-cloud-50': theme === 'cloud',
      })}
    >
      <section
        className={cls(
          'app-container w-full',
          'mx-auto',
          'flex',
          'flex-col',
          'px-2 lg:px-0',
          'pb-2 lg:pb-4',
          'pt-4 lg:pt-8',
        )}
      >
        <div
          className={cls(
            'flex xs-only:justify-center',
            'flex-wrap',
            'gap-x-5',
            'sm-and-below:gap-y-2',
            'border-b',
            'border-cloud-200',
            'pb-4',
            { 'flex justify-center items-center pb-0 border-none': type === 'onlySocials' },
          )}
        >
          {type !== 'onlySocials' && (
            <div className="flex xs-only:items-center flex-col lg:min-w-80 lg:w-80">
              <LogoComp
                orientation={LogoOrientation.HORIZONTAL}
                style={LogoStyles.APP}
                color={theme === 'dark' ? LogoColor.WHITE : LogoColor.BLACK}
                height={31}
              />
              <span className="text-cloud-400 text-lg mt-3 xs-only:text-center">
                Swap your NFTs in a safe and secure way, your way!
              </span>
            </div>
          )}
          {type !== 'onlySocials' && (
            <nav className="flex lg:ml-8">
              <div className="sm-and-below:mr-12">
                <p className="text-md font-bold mb-1">Company</p>
                <ul title="Company">
                  <li className="text-sm mb-1">
                    <a href="/about-us">About us</a>
                  </li>
                  <li className="text-sm">
                    <a href="/faq">FAQ</a>
                  </li>
                </ul>
              </div>
              <div className="md:ml-4">
                <p className="text-md font-bold mb-1">Legal</p>
                <ul>
                  <li className="text-sm mb-1">
                    <a href="/privacy-policy" className="text-sm">
                      Privacy Policy
                    </a>
                  </li>
                  <li className="text-sm">
                    <a href="/terms-of-use" className="text-sm">
                      Terms of Use
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          )}
          <div
            className={cls('flex gap-x-2', {
              'lg:ml-auto': type !== 'onlySocials',
              'ml-0': type === 'onlySocials',
            })}
          >
            <a href="https://twitter.com/swapkiwi" target="_blank" rel="noreferrer">
              <img className="h-3" src={require(`../../../assets/svg/stickers/Social/twitter.svg`)?.default} />
            </a>
            <a href="https://discord.gg/FvvsSS8ny7" target="_blank" rel="noreferrer">
              <img className="h-3" src={require(`../../../assets/svg/stickers/Social/discord.svg`)?.default} />
            </a>
          </div>
        </div>
        {type !== 'onlySocials' && (
          <a
            href="https://www.niftyhorde.com/"
            target="_blank"
            rel="noreferrer"
            className="text-cloud-400 text-base text-center mt-4"
          >
            © {year} niftyhorde GmbH
          </a>
        )}
      </section>
    </footer>
  );
};
